export default "__VITE_ASSET__2d83f204__"